import { render, staticRenderFns } from "./ChatMod.vue?vue&type=template&id=4ef30d56"
import script from "./ChatMod.vue?vue&type=script&lang=js"
export * from "./ChatMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports